import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { useUrlSearchParams } from "use-url-search-params";
import { Breadcrumb, Table } from 'antd';

import Pagination from "containers/Pagination";

import Title from "components/Title";
import Spacer from "components/Spacer";
import Container from "components/Container";
import { useList } from 'modules/aiSearch/hooks';

const PER_PAGE = 20;

const AISearch = () => {
  const { t } = useTranslation();
  const [params, setParams] = useUrlSearchParams();
  const [perPage, setPerPage] = useState(PER_PAGE);
  const search = params.search || '';

  const [loading, _] = useState(false);
  const [page, __] = useState(1);

  const defaultParams = {
    page: params.page,
    perPage,
    searchText: search,
    perPage: PER_PAGE
  }
  const { items, meta, isFetched } = useList({
    params: defaultParams
  });

  const columns = [
    {
      title: '№',
      render: (_, __, index) => (page - 1) * PER_PAGE + index + 1,
      width: 60
    },
    {
      title: t('ai_search_score'),
      dataIndex: 'score',
      key: 'score',
      width: 120
    },
    {
      title: t('ai_search_name'),
      dataIndex: 'text',
      key: 'text'
    }
  ];

  return (
    <Container>
      <Spacer size={35} />

      <Breadcrumb separator=">">
        <Breadcrumb.Item href="/">{t('home')}</Breadcrumb.Item>
        <Breadcrumb.Item>{t('ai_search')}</Breadcrumb.Item>
      </Breadcrumb>

      <Spacer size={32} />

      <Title align="left" text={`${t('ai_search')}: "${search}"`} />

      <Spacer size={40} />

      <Table
        rowKey="id"
        columns={columns}
        dataSource={items}
        pagination={false}
        loading={loading}
        scroll={{ x: 800 }}
        locale={{
          emptyText: t("functions-not-found")
        }}
      />

      <Spacer size={32} />

      <Pagination
        current={meta.page}
        perPage={meta.perPage}
        total={Math.ceil(meta.total / PER_PAGE)}
        currentItems={items.length}
        totalItems={meta.total}
        onChange={page => setParams({ page })}
        onPerPageChange={perPage => setParams({ perPage })}
      />

      <Spacer size={140} />
    </Container>
  );
};

export default AISearch;
